/**
 * Check if the user signed in via email link and hasn't linked a provider yet.
 * These users need to complete account linking before accessing the app.
 */
export const isEmailLinkSignin = (user: object | null | undefined): boolean => {
  if (!user || !("reloadUserInfo" in user)) return false;
  if (typeof user.reloadUserInfo !== "object") return false;
  if (user.reloadUserInfo === null) return false;
  if (!("emailLinkSignin" in user.reloadUserInfo)) return false;
  if (!("providerUserInfo" in user.reloadUserInfo)) return false;
  if (!Array.isArray(user.reloadUserInfo.providerUserInfo)) return false;
  if (user.reloadUserInfo.providerUserInfo.length === 0) return false;
  const providerUserInfo = user.reloadUserInfo.providerUserInfo[0] as
    { providerId: string } | undefined;
  if (!providerUserInfo) return false;
  if (providerUserInfo.providerId !== "password") return false;
  return Boolean(user.reloadUserInfo.emailLinkSignin);
};
